import React from 'react'
import { withStyles, Grid, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import Tr from 'translations/Translations';

const style = theme => ({
	root: {

	},
	label: {
		fontWeight: theme.typography.fontWeightBold
	}
})

function InfoDataElement({
	classes,
	trKey,
	value,
}) {
	return (
		<Grid item>
			<Typography component='span' variant='body1' className={classes.label}>
				{Tr(trKey)}:{' '}
			</Typography>
			<Typography component='span' variant='body1'>
				{value}
			</Typography>
		</Grid>
	)
}

InfoDataElement.propTypes = {
	classes: PropTypes.any,
}

export default withStyles(style)(InfoDataElement);